<!-- Feature sub nav -->
@if (showFeatureSubNav) {
  @if (isSite) {
    <portal-enterprise-site-sub-nav></portal-enterprise-site-sub-nav>
  }
  @if (isCallCenter) {
    <portal-call-center-queue-sub-nav></portal-call-center-queue-sub-nav>
  }
  @if (isAcd) {
    <portal-acd-sub-nav></portal-acd-sub-nav>
  }
} @else {
  <!-- End user sub nav -->
  @if (isOnEndUserLevel$ | async) {
    <portal-enterprise-end-user-sub-nav></portal-enterprise-end-user-sub-nav>
  }
  <!-- Enterprise level sub navs -->
  @if (isOnEnterpriseLevel$ | async) {
    <!-- Settings -->
    <portal-enterprise-settings-sub-nav></portal-enterprise-settings-sub-nav>
    <!-- End Users -->
    <portal-enterprise-end-users-sub-nav></portal-enterprise-end-users-sub-nav>
    <!-- Calendar -->
    <portal-enterprise-calendar-sub-nav></portal-enterprise-calendar-sub-nav>
    <!-- Phone Book -->
    <portal-enterprise-phone-book-sub-nav></portal-enterprise-phone-book-sub-nav>
    <!-- Call Center -->
    <portal-enterprise-call-center-sub-nav></portal-enterprise-call-center-sub-nav>
    <!-- A/B-Routing -->
    <portal-enterprise-ab-routing-sub-nav></portal-enterprise-ab-routing-sub-nav>
    <!-- Journal -->
    <portal-enterprise-journal-sub-nav></portal-enterprise-journal-sub-nav>
    <!-- Trunks -->
    <portal-enterprise-trunk-sub-nav></portal-enterprise-trunk-sub-nav>
  }
}
